(function () {
  const SELECTOR = '[data-rf-scenario-picker]';
  const LISTING_SELECTOR = '[data-rf-collection-listing]';

  function parseValues(raw) {
    return String(raw || '')
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);
  }

  function getAvailableFilterValues(paramName) {
    const listing = document.querySelector(LISTING_SELECTOR);
    if (!listing || !paramName) return [];

    const values = new Set();
    listing.querySelectorAll(`[data-rf-filter-radio][data-param-name="${paramName}"]`).forEach((btn) => {
      if (btn.disabled || btn.classList.contains('is-disabled')) return;
      if (btn.dataset.paramValue) values.add(btn.dataset.paramValue);
    });

    return Array.from(values);
  }

  function resolveFilterValues(requested, paramName) {
    if (!requested.length) return requested;

    const available = getAvailableFilterValues(paramName);
    if (!available.length) return requested;

    const matched = requested.filter((value) => available.includes(value));
    if (matched.length) return matched;

    const availableLower = new Map(available.map((value) => [value.toLowerCase(), value]));
    const caseMatched = requested
      .map((value) => availableLower.get(value.toLowerCase()))
      .filter(Boolean);

    return caseMatched.length ? caseMatched : [];
  }

  function buildSearchParams(card, section) {
    const current = new URLSearchParams(window.location.search);
    const params = new URLSearchParams();
    const wattageParam = section.dataset.wattageFilterParam || '';
    const useCaseParam = section.dataset.useCaseFilterParam || '';
    const filterByUseCase = section.dataset.filterByUseCase === 'true';
    const useCaseValues = parseValues(card.dataset.useCaseValue);
    const wattageValues = resolveFilterValues(parseValues(card.dataset.wattageValues), wattageParam);

    if (current.get('sort_by')) {
      params.set('sort_by', current.get('sort_by'));
    }

    if (filterByUseCase && useCaseParam && useCaseValues.length) {
      resolveFilterValues(useCaseValues, useCaseParam).forEach((value) => {
        params.append(useCaseParam, value);
      });
    }

    wattageValues.forEach((value) => {
      if (wattageParam) params.append(wattageParam, value);
    });

    return params.toString();
  }

  function animateGrid() {
    const grid = document.getElementById('CollectionProductGrid');
    if (!grid) return;

    grid.classList.remove('is-visible');
    grid.classList.add('rf-scenario-grid-fade');

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        grid.classList.add('is-visible');
      });
    });
  }

  function syncActiveCard(section, card) {
    section.querySelectorAll('[data-rf-scenario-card]').forEach((item) => {
      item.classList.toggle('is-active', item === card);
    });
  }

  function applyScenarioFilter(card, section) {
    const searchParams = buildSearchParams(card, section);

    animateGrid();

    if (window.RfCollectionListing?.renderSearchParams?.(searchParams)) {
      window.setTimeout(() => animateGrid(), 350);
      return true;
    }

    if (typeof CollectionFiltersForm !== 'undefined' && typeof CollectionFiltersForm.renderPage === 'function') {
      CollectionFiltersForm.renderPage(searchParams, null, true);
      window.setTimeout(() => animateGrid(), 350);
      return true;
    }

    const nextUrl = `${window.location.pathname}?${searchParams}`;
    window.location.href = nextUrl;
    return false;
  }

  function initSection(section) {
    if (section.dataset.rfScenarioInit === 'true') return;
    section.dataset.rfScenarioInit = 'true';

    section.querySelectorAll('[data-rf-scenario-card]').forEach((card) => {
      card.addEventListener('click', (event) => {
        event.preventDefault();
        syncActiveCard(section, card);
        applyScenarioFilter(card, section);
      });
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector(SELECTOR);
    if (section) initSection(section);
  });
})();
